import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";

// Animated SVG: granules -> hopper -> drying -> melt -> extruder/mold -> part
export function ProcessFlow({ mode = "extrusion" }) {
  const { lang } = useLang();
  const steps = mode === "injection"
    ? (lang === "de" ? ["Granulat", "Trocknung", "Plastifizierung", "Einspritzung", "Bauteil"] : ["Granules", "Drying", "Plasticising", "Injection", "Part"])
    : (lang === "de" ? ["Granulat", "Trocknung", "Aufschmelzen", "Schnecke", "Profil"] : ["Granules", "Drying", "Melting", "Screw", "Profile"]);
  const xs = [40, 245, 450, 655, 860];

  return (
    <div className="w-full" data-testid={`process-${mode}`}>
      <svg viewBox="0 0 900 200" className="w-full h-auto" role="img" aria-label={`TPU ${mode} Prozess`}>
        <line x1="40" y1="100" x2="860" y2="100" stroke="#e4e9f0" strokeWidth="2" />
        <motion.line
          x1="40" y1="100" x2="860" y2="100" stroke="#E2611C" strokeWidth="2"
          strokeDasharray="820" initial={{ strokeDashoffset: 820 }}
          animate={{ strokeDashoffset: 0 }}
          transition={{ duration: 1.8, ease: "easeInOut" }}
        />
        {xs.map((cx, i) => (
          <motion.g key={i}
            initial={{ opacity: 0, scale: 0.6 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.2 + i * 0.22, duration: 0.5 }}
            style={{ transformOrigin: `${cx}px 100px` }}
          >
            <circle cx={cx} cy="100" r="9" fill="#16181D" />
            <circle cx={cx} cy="100" r="16" fill="none" stroke="#E2611C" strokeWidth="1.5" opacity="0.5" />
            <text x={cx} y="150" textAnchor="middle" fontSize="13" fill="#4a4d52" fontFamily="DM Sans">{steps[i]}</text>
            <text x={cx} y="62" textAnchor="middle" fontSize="11" fill="#E2611C" fontFamily="JetBrains Mono">0{i + 1}</text>
          </motion.g>
        ))}
        <motion.circle cy="100" r="5" fill="#E2611C"
          initial={{ cx: 40 }} animate={{ cx: [40, 860] }} transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }} />
      </svg>
    </div>
  );
}
